export const skillsData = [
  "HTML",
  "CSS",
  "Javascript",
  "Typescript",
  "Python",
  "React",
  "Mongo",
  "GraphQL",
  "Redis",
  "PostgreSql",
  "Node",
  "Redux",
  "Socket.io",
  "Next",
  "Three",
  "Qt",
  "Data structures and Algorithms",
  "Docker",
];
